function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_5703"
}, /*#__PURE__*/React.createElement("rect", {
  width: 153,
  height: 233,
  x: 0,
  y: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_5706"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L1000,0 L1000,1000 L0,1000z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_5714"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L600,0 L600,600 L0,600z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_5715"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  clipRule: "nonzero",
  d: " M483,78 C483,78 124.5,91 124.5,91 C124.5,91 124.5,334 124.5,334 C124.5,334 485.5,332 485.5,334 C485.5,336 485.5,196.5 485.5,196.5 C485.5,196.5 438.5,196.5 438.5,196.5 C438.5,196.5 438,261 371,261 C307.5,261 303.5,196.5 303.5,196.5 C303.5,196.5 287.5,265 226,265 C156.5,265 158.5,196.5 158.5,196.5 C158.5,196.5 159.5,179.5 159.5,179.5 C159.5,179.5 158.5,127.5 225.5,127.5 C294.5,127.5 302,179.5 302,179.5 C302,179.5 299.5,123 370,123 C447.5,123 438.5,179.5 438.5,179.5 C438.5,179.5 483,179.5 483,179.5 C483,179.5 483,78 483,78",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_5736"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L141,0 L141,78 L0,78z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_5749"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L96,0 L96,80 L0,80z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_5759"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L88,0 L88,116 L0,116z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_5775"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  clipRule: "nonzero",
  d: " M18.773000717163086,-13.767000198364258 C-4.193999767303467,-13.767000198364258 -5.23799991607666,-1.7669999599456787 -5.23799991607666,21.232999801635742 C-5.23799991607666,37.483001708984375 -5.760000228881836,53.733001708984375 19.034000396728516,53.733001708984375 C37.56399917602539,53.733001708984375 40.435001373291016,33.733001708984375 40.435001373291016,23.232999801635742 C40.435001373291016,7.732999801635742 41.7400016784668,-13.767000198364258 18.773000717163086,-13.767000198364258",
  fillOpacity: 1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_5781"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  clipRule: "nonzero",
  d: " M21.773000717163086,-13.767000198364258 C-1.194000005722046,-13.767000198364258 -2.23799991607666,-1.7669999599456787 -2.23799991607666,21.232999801635742 C-2.23799991607666,37.483001708984375 -2.759999990463257,53.733001708984375 22.034000396728516,53.733001708984375 C40.56399917602539,53.733001708984375 43.435001373291016,33.733001708984375 43.435001373291016,23.232999801635742 C43.435001373291016,7.732999801635742 44.7400016784668,-13.767000198364258 21.773000717163086,-13.767000198364258",
  fillOpacity: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(119,200,0)",
  fillOpacity: 1,
  d: " M18.760000228881836,0.46000000834465027 C18.760000228881836,0.46000000834465027 204.5399932861328,46.689998626708984 204.5399932861328,46.689998626708984 C214.49000549316406,49.16999816894531 219.1300048828125,60.630001068115234 213.6999969482422,69.30999755859375 C187.5800018310547,111.05999755859375 136.77000427246094,131.72999572753906 87.69000244140625,119.5199966430664 C38.61000061035156,107.30000305175781 3.4600000381469727,65.23999786376953 0.03999999910593033,16.139999389648438 C-0.6800000071525574,5.920000076293945 8.8100004196167,-2.0199999809265137 18.760000228881836,0.46000000834465027z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(119,200,0)",
  fillOpacity: 1,
  d: " M197.24000549316406,0.46000000834465027 C207.19000244140625,-2.0199999809265137 216.67999267578125,5.920000076293945 215.9600067138672,16.139999389648438 C212.5399932861328,65.23999786376953 177.38999938964844,107.30000305175781 128.30999755859375,119.5199966430664 C79.2300033569336,131.72999572753906 28.420000076293945,111.05999755859375 2.299999952316284,69.30999755859375 C-3.130000114440918,60.630001068115234 1.5099999904632568,49.16999816894531 11.460000038146973,46.689998626708984 C11.460000038146973,46.689998626708984 197.24000549316406,0.46000000834465027 197.24000549316406,0.46000000834465027z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(244,144,0)",
  fillOpacity: 1,
  d: " M4.429999828338623,5.25 C10.649999618530273,-1.4199999570846558 21.09000015258789,-1.7799999713897705 27.75,4.429999828338623 C27.75,4.429999828338623 46.77000045776367,22.15999984741211 46.77000045776367,22.15999984741211 C53.43000030517578,28.3799991607666 53.79999923706055,38.81999969482422 47.58000183105469,45.47999954223633 C41.369998931884766,52.150001525878906 30.93000030517578,52.5099983215332 24.260000228881836,46.29999923706055 C24.260000228881836,46.29999923706055 5.25,28.56999969482422 5.25,28.56999969482422 C-1.4199999570846558,22.350000381469727 -1.7799999713897705,11.90999984741211 4.429999828338623,5.25z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(119,200,0)",
  fillOpacity: 1,
  d: " M59.61000061035156,3.390000104904175 C92.87999725341797,17.459999084472656 115.68000030517578,24.5 128,24.5 C140.24000549316406,24.5 162.6699981689453,17.549999237060547 195.3000030517578,3.6700000762939453 C217.10000610351562,-5.610000133514404 242.2899932861328,4.539999961853027 251.57000732421875,26.34000015258789 C253.8300018310547,31.649999618530273 255,37.369998931884766 255,43.13999938964844 C255,43.13999938964844 255,175.5 255,175.5 C255,245.9199981689453 197.9199981689453,303 127.5,303 C57.08000183105469,303 0,245.9199981689453 0,175.5 C0,175.5 0,42.900001525878906 0,42.900001525878906 C0,19.209999084472656 19.209999084472656,0 42.900001525878906,0 C48.63999938964844,0 54.31999969482422,1.149999976158142 59.61000061035156,3.390000104904175z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", null));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,223,0)",
  fillOpacity: 1,
  d: " M0.09000000357627869,0.05999999865889549 C12.899999618530273,14.210000038146973 36.439998626708984,14.140000343322754 49,0 C49,33.02000045776367 49,82.25 49,82 C49,81.75 0.09000000357627869,82 0.09000000357627869,82 C0.09000000357627869,82 -0.09000000357627869,45.86000061035156 0.09000000357627869,0.05999999865889549z"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,223,0)",
  fillOpacity: 1,
  d: " M47.630001068115234,0 C47.630001068115234,0 51.369998931884766,0 51.369998931884766,0 C77.68000030517578,0 99,21.31999969482422 99,47.630001068115234 C99,47.630001068115234 99,78.37000274658203 99,78.37000274658203 C99,104.68000030517578 77.68000030517578,126 51.369998931884766,126 C51.369998931884766,126 47.630001068115234,126 47.630001068115234,126 C21.31999969482422,126 0,104.68000030517578 0,78.37000274658203 C0,78.37000274658203 0,47.630001068115234 0,47.630001068115234 C0,21.31999969482422 21.31999969482422,0 47.630001068115234,0z"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,223,0)",
  fillOpacity: 1,
  d: " M47.630001068115234,0 C47.630001068115234,0 51.369998931884766,0 51.369998931884766,0 C77.68000030517578,0 99,21.31999969482422 99,47.630001068115234 C99,47.630001068115234 99,78.37000274658203 99,78.37000274658203 C99,104.68000030517578 77.68000030517578,126 51.369998931884766,126 C51.369998931884766,126 47.869998931884766,126 47.869998931884766,126 C21.709999084472656,126 0.44999998807907104,104.91000366210938 0.23999999463558197,78.75 C0.23999999463558197,78.75 0,48 0,48 C-0.20999999344348907,21.700000762939453 20.950000762939453,0.20999999344348907 47.25,0 C47.369998931884766,0 47.5,0 47.630001068115234,0z"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,223,0)",
  fillOpacity: 1,
  d: " M10.760000228881836,1.4700000286102295 C10.760000228881836,1.4700000286102295 49.119998931884766,43.13999938964844 49.119998931884766,43.13999938964844 C51.130001068115234,45.369998931884766 50.380001068115234,48.91999816894531 47.63999938964844,50.13999938964844 C34.45000076293945,56 18.719999313354492,52.70000076293945 8.800000190734863,41.689998626708984 C-1.1299999952316284,30.68000030517578 -2.7699999809265137,14.699999809265137 4.449999809265137,2.2100000381469727 C5.949999809265137,-0.38999998569488525 8.739999771118164,-0.7699999809265137 10.760000228881836,1.4700000286102295z"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,223,0)",
  fillOpacity: 1,
  d: " M11.569999694824219,1.4700000286102295 C11.569999694824219,1.4700000286102295 49.13999938964844,43.16999816894531 49.13999938964844,43.16999816894531 C51.15999984741211,45.400001525878906 50.40999984741211,48.95000076293945 47.65999984741211,50.16999816894531 C34.470001220703125,56.029998779296875 18.729999542236328,52.72999954223633 8.8100004196167,41.709999084472656 C-1.1200000047683716,30.690000534057617 -2.7699999809265137,14.699999809265137 4.449999809265137,2.2100000381469727 C5.949999809265137,-0.38999998569488525 9.550000190734863,-0.7699999809265137 11.569999694824219,1.4700000286102295z"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,223,0)",
  fillOpacity: 1,
  d: " M38.720001220703125,1.4700000286102295 C40.72999954223633,-0.7699999809265137 44.34000015258789,-0.38999998569488525 45.84000015258789,2.2100000381469727 C53.060001373291016,14.699999809265137 51.40999984741211,30.690000534057617 41.47999954223633,41.709999084472656 C31.549999237060547,52.72999954223633 15.8100004196167,56.029998779296875 2.619999885559082,50.16999816894531 C-0.11999999731779099,48.95000076293945 -0.8700000047683716,45.400001525878906 1.1399999856948853,43.16999816894531 C1.1399999856948853,43.16999816894531 38.720001220703125,1.4700000286102295 38.720001220703125,1.4700000286102295z"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,223,0)",
  fillOpacity: 1,
  d: " M38.720001220703125,1.4700000286102295 C40.72999954223633,-0.7699999809265137 44.34000015258789,-0.38999998569488525 45.84000015258789,2.2100000381469727 C53.060001373291016,14.699999809265137 51.40999984741211,30.690000534057617 41.47999954223633,41.709999084472656 C31.549999237060547,52.72999954223633 15.8100004196167,56.029998779296875 2.619999885559082,50.16999816894531 C-0.11999999731779099,48.95000076293945 -0.8700000047683716,45.400001525878906 1.1399999856948853,43.16999816894531 C1.1399999856948853,43.16999816894531 38.720001220703125,1.4700000286102295 38.720001220703125,1.4700000286102295z"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  fillOpacity: 1,
  d: " M35,0 C54.33000183105469,0 70,15.670000076293945 70,35 C70,35 70,56 70,56 C70,75.33000183105469 54.33000183105469,91 35,91 C15.670000076293945,91 0,75.33000183105469 0,56 C0,56 0,35 0,35 C0,15.670000076293945 15.670000076293945,0 35,0z"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  fillOpacity: 1,
  d: " M35,0 C54.33000183105469,0 70,15.670000076293945 70,35 C70,35 70,56 70,56 C70,75.33000183105469 54.33000183105469,91 35,91 C15.670000076293945,91 0,75.33000183105469 0,56 C0,56 0,35 0,35 C0,15.670000076293945 15.670000076293945,0 35,0z"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(75,75,75)",
  fillOpacity: 1,
  d: " M16.5,0 C25.610000610351562,0 33,7.389999866485596 33,16.5 C33,16.5 33,34.5 33,34.5 C33,43.61000061035156 25.610000610351562,51 16.5,51 C7.389999866485596,51 0,43.61000061035156 0,34.5 C0,34.5 0,16.5 0,16.5 C0,7.389999866485596 7.389999866485596,0 16.5,0z"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(75,75,75)",
  fillOpacity: 1,
  d: " M16.5,0 C25.610000610351562,0 33,7.389999866485596 33,16.5 C33,16.5 33,34.5 33,34.5 C33,43.61000061035156 25.610000610351562,51 16.5,51 C7.389999866485596,51 0,43.61000061035156 0,34.5 C0,34.5 0,16.5 0,16.5 C0,7.389999866485596 7.389999866485596,0 16.5,0z"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  fillOpacity: 1,
  d: " M0,-10.5 C5.794950008392334,-10.5 10.5,-5.794950008392334 10.5,0 C10.5,5.794950008392334 5.794950008392334,10.5 0,10.5 C-5.794950008392334,10.5 -10.5,5.794950008392334 -10.5,0 C-10.5,-5.794950008392334 -5.794950008392334,-10.5 0,-10.5z"
}));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,255,255)",
  fillOpacity: 1,
  d: " M0,-10.5 C5.794950008392334,-10.5 10.5,-5.794950008392334 10.5,0 C10.5,5.794950008392334 5.794950008392334,10.5 0,10.5 C-5.794950008392334,10.5 -10.5,5.794950008392334 -10.5,0 C-10.5,-5.794950008392334 -5.794950008392334,-10.5 0,-10.5z"
}));

var _ref21 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(244,144,0)",
  fillOpacity: 1,
  d: " M18,0 C27.940000534057617,0 36,8.0600004196167 36,18 C36,18 36,48 36,48 C36,57.939998626708984 27.940000534057617,66 18,66 C8.0600004196167,66 0,57.939998626708984 0,48 C0,48 0,18 0,18 C0,8.0600004196167 8.0600004196167,0 18,0z"
}));

var _ref22 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(183,108,0)",
  fillOpacity: 1,
  d: " M14,0 C21.729999542236328,0 28,6.269999980926514 28,14 C28,14 28,34 28,34 C28,41.72999954223633 21.729999542236328,48 14,48 C6.269999980926514,48 0,41.72999954223633 0,34 C0,34 0,14 0,14 C0,6.269999980926514 6.269999980926514,0 14,0z"
}));

var _ref23 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(244,144,0)",
  fillOpacity: 1,
  d: " M35.97999954223633,45.207000732421875 C35.97999954223633,55.14699935913086 31.736000061035156,66.0479965209961 18,66 C3.3970000743865967,65.9489974975586 -0.019999999552965164,55.14699935913086 -0.019999999552965164,45.207000732421875 C-0.019999999552965164,45.207000732421875 35.97999954223633,45.207000732421875 35.97999954223633,45.207000732421875z"
}));

var _ref24 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,193,0)",
  fillOpacity: 1,
  d: " M0,20.290000915527344 C2.0999999046325684,8.869999885559082 12.600000381469727,0 25.709999084472656,0 C37.400001525878906,0 47.900001525878906,8.869999885559082 50,20.290000915527344 C49.869998931884766,20.770000457763672 50,21.739999771118164 50,21.739999771118164 C50,21.739999771118164 25,26 25,26 C25,26 0,21.739999771118164 0,21.739999771118164 C0,21.739999771118164 0.12999999523162842,20.770000457763672 0,20.290000915527344z"
}));

var _ref25 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(255,221,0)",
  fillOpacity: 1,
  d: " M4.800000190734863,7.929999828338623 C2.940000057220459,8.609999656677246 0.8899999856948853,7.650000095367432 0.2199999988079071,5.800000190734863 C-0.46000000834465027,3.940000057220459 0.5,1.8899999856948853 2.3499999046325684,1.2200000286102295 C6.809999942779541,-0.4099999964237213 11.34000015258789,-0.4099999964237213 15.800000190734863,1.2200000286102295 C17.649999618530273,1.8899999856948853 18.610000610351562,3.940000057220459 17.940000534057617,5.800000190734863 C17.260000228881836,7.650000095367432 15.210000038146973,8.609999656677246 13.350000381469727,7.929999828338623 C10.479999542236328,6.889999866485596 7.679999828338623,6.889999866485596 4.800000190734863,7.929999828338623z"
}));

var _ref26 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,223,0)",
  fillOpacity: 1,
  d: " M2.5399999618530273,0.009999999776482582 C2.5399999618530273,0.009999999776482582 34.619998931884766,0 34.619998931884766,0 C36.34000015258789,0 37.560001373291016,1.590000033378601 37.029998779296875,3.130000114440918 C34.47999954223633,10.569999694824219 27.049999237060547,15.710000038146973 18.56999969482422,15.710000038146973 C10.100000381469727,15.720000267028809 2.6700000762939453,10.579999923706055 0.12999999523162842,3.1500000953674316 C-0.4099999964237213,1.600000023841858 0.8199999928474426,0.009999999776482582 2.5399999618530273,0.009999999776482582z"
}));

var _ref27 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,223,0)",
  fillOpacity: 1,
  d: " M2.5399999618530273,0.009999999776482582 C2.5399999618530273,0.009999999776482582 34.619998931884766,0 34.619998931884766,0 C36.34000015258789,0 37.560001373291016,1.590000033378601 37.029998779296875,3.130000114440918 C34.47999954223633,10.569999694824219 27.049999237060547,15.710000038146973 18.56999969482422,15.710000038146973 C10.100000381469727,15.720000267028809 2.6700000762939453,10.579999923706055 0.12999999523162842,3.1500000953674316 C-0.4099999964237213,1.600000023841858 0.8199999928474426,0.009999999776482582 2.5399999618530273,0.009999999776482582z"
}));

var _ref28 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,223,0)",
  fillOpacity: 1,
  d: " M2.5399999618530273,0.009999999776482582 C2.5399999618530273,0.009999999776482582 34.619998931884766,0 34.619998931884766,0 C36.34000015258789,0 37.560001373291016,1.590000033378601 37.029998779296875,3.130000114440918 C34.47999954223633,10.569999694824219 27.049999237060547,15.710000038146973 18.56999969482422,15.710000038146973 C10.100000381469727,15.720000267028809 2.6700000762939453,10.579999923706055 0.12999999523162842,3.1500000953674316 C-0.4099999964237213,1.600000023841858 0.8199999928474426,0.009999999776482582 2.5399999618530273,0.009999999776482582z"
}));

var _ref29 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,223,0)",
  fillOpacity: 1,
  d: " M71.44000244140625,0 C71.44000244140625,0 77.27999877929688,31.459999084472656 77.27999877929688,31.459999084472656 C58.470001220703125,34.959999084472656 36.93000030517578,41.93000030517578 12.720000267028809,52.40999984741211 C12.720000267028809,52.40999984741211 0,23.049999237060547 0,23.049999237060547 C26.280000686645508,11.670000076293945 50.060001373291016,3.9700000286102295 71.44000244140625,0z"
}));

var _ref30 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,223,0)",
  fillOpacity: 1,
  d: " M78.16000366210938,22.09000015258789 C78.16000366210938,22.09000015258789 64.9000015258789,51.220001220703125 64.9000015258789,51.220001220703125 C47.4900016784668,43.290000915527344 25.84000015258789,36.63999938964844 0,31.350000381469727 C0,31.350000381469727 6.420000076293945,0 6.420000076293945,0 C34.47999954223633,5.75 58.380001068115234,13.09000015258789 78.16000366210938,22.09000015258789z"
}));

var _ref31 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,224,0)",
  fillOpacity: 1,
  d: " M35,0 C54.33000183105469,0 70,15.670000076293945 70,35 C70,35 70,56 70,56 C70,75.33000183105469 54.33000183105469,91 35,91 C15.670000076293945,91 0,75.33000183105469 0,56 C0,56 0,35 0,35 C0,15.670000076293945 15.670000076293945,0 35,0z"
}));

var _ref32 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1.2533299922943115,0,0,1.2533299922943115,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgb(142,224,0)",
  fillOpacity: 1,
  d: " M35,0 C54.33000183105469,0 70,15.670000076293945 70,35 C70,35 70,56 70,56 C70,75.33000183105469 54.33000183105469,91 35,91 C15.670000076293945,91 0,75.33000183105469 0,56 C0,56 0,35 0,35 C0,15.670000076293945 15.670000076293945,0 35,0z"
}));

var SvgBirdGreenIcon = function SvgBirdGreenIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 153 233",
    width: 53,
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_5703)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_5706)",
    transform: "matrix(0.22814983129501343,0.20987533032894135,-0.20987533032894135,0.22814983129501343,3.2769012451171875,-79.4515380859375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9492719173431396,-0.31445640325546265,0.31445640325546265,0.9492719173431396,216.48605346679688,405.0934753417969)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref3), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4908725619316101,0.8712313771247864,-0.8712313771247864,0.4908725619316101,608.6009521484375,341.3097229003906)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref4), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,315.1210021972656,592.6430053710938)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref5), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,340.8270263671875,255.3330078125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref6), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _ref7), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,469.9200439453125,330.53399658203125)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref8), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,362.1330261230469,311.7330322265625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref9), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,516.2930297851562,310.4800109863281)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref10), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,418.4580383300781,286.0660095214844)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref11), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,393.3540344238281,298.5610046386719)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref12), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,519.8030395507812,286.0270080566406)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref13), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,543.6160278320312,298.5610046386719)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref14), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,378.426025390625,334.29302978515625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref15), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,533.8400268554688,334.29302978515625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref16), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,408.50604248046875,359.3600158691406)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref17), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,550.133056640625,359.3600158691406)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref18), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_5781)",
    transform: "matrix(1,0,0,1,550.760009765625,371.26702880859375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref19), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_5775)",
    transform: "matrix(1,0,0,1,411.6390380859375,371.26702880859375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref20), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_5759)",
    transform: "matrix(1,0,0,1,456.0000305175781,382)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,21.475000381469727,19.720001220703125)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref21), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,26.487998962402344,28.49300193786621)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref22), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,21.475000381469727,-15.280000686645508)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref23)), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_5749)",
    transform: "matrix(1,0,0,1,451.7500305175781,371)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,16.733001708984375,26.454002380371094)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref24), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,36.05900192260742,30.751998901367188)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref25)), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_5736)",
    transform: "matrix(1,0,0,1,429.5000305175781,521)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,11.346000671386719,14.293000221252441)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref26), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,81.53300476074219,14.293000221252441)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref27), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,46.439998626708984,48.132999420166016)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref28)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,535.89501953125,397.2980041503906)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref29), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,369.67803955078125,397.8740234375)",
    opacity: 1,
    style: {
      display: "none"
    }
  }, _ref30), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_5714)",
    transform: "matrix(1,0,0,1,200.00003051757812,200.00001525878906)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_5715)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0800000429153442,0,0,1.0800000429153442,174.91664123535156,129.7308349609375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref31), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0800000429153442,0,0,1.0800000429153442,330.33062744140625,129.7308349609375)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _ref32))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBirdGreenIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bird-green-icon.da1606fc.svg";
export { ForwardRef as ReactComponent };